<template>
  <div style='margin-top: 40px; font-weight:600; color:#333333; margin-left:-5px; margin-right: -5px;'>
    <div class ='row no-gutters'>
      <div class='col'>
        <div id='nav_previous' class='d-none' style='padding-top:9px;'>
          <a href='javascript:void(0);' @click="changeStep('previous')" class='row no-gutters botNavLink'>
            <div class='col-auto my-auto'>
              <img src='../assets/images/leftarrow.png' style='margin-left:15px;' :alt="$t('text.back')+' link'"/>
            </div>
            <div class='col-auto my-auto' style='padding-left: 15px; height:25px;'>
              {{$t('text.back')}}
            </div>
          </a>
        </div>
        <div id='nav_letsgetstartedwrapper'>
          <div id='nav_letsgetstarted' class='row d-none d-sm-block'>
            <button @click="changeStep('next')" class='btn btn-primary' style='margin-left:35px;'>{{$t('text.page1_button')}}</button>
          </div>
        </div>
        <div id='nav_printconfirmation' class='row d-none d-print-none'>
          <!--<button @click="printPage()" class='btn btn-primary' style='margin-left:35px; min-width: 200px;'>{{$t('text.page13_print')}}</button>-->
        </div>
      </div>
      <div class='col-auto col-sm'>
        <div id='nav_letsgetstartedwrapper2'>
          <div id='nav_letsgetstarted2' class='row d-block d-sm-none'>
            <button @click="changeStep('next')" class='btn btn-primary'>{{$t('text.page1_button')}}</button>
          </div>
        </div>
        <div id='nav_previouscenter' class='d-none'>
          <a href='javascript:void(0);' @click="changeStep('previous')" class='botNavLink row no-gutters'>
            <div class='col'></div>
            <div class='col-auto my-auto'>
              <img src='../assets/images/leftarrow.png' style='margin-left:15px;' :alt="$t('text.back')+' link'"/>
            </div>
            <div class='col-auto my-auto' style='padding-left: 15px; height:25px;'>
              {{$t('text.back')}}
            </div>
            <div class='col'></div>
          </a>
        </div>
      </div>
      <div class='col'>
        <div id='nav_next'>
          <div id='nav_next_enabled' class='no-gutters hoverSpot pull-right d-none'>
            <a href='javascript:void(0);' @click="changeStep('next')" class='botNavLink row no-gutters'>
              <div class='col'></div>
              <div class='col-auto my-auto' style='padding-right:20px;height:25px;color: #336699'>
                {{$t('text.continue')}}
              </div>
              <div class='col-auto my-auto'>
                <img id='proceed-enabled' alt='' src='../assets/images/rightarrow_enabled.png' style='margin-right:15px;'/>
              </div>
            </a>
          </div>
          <div id='nav_next_disabled' class='no-gutters hoverSpot pull-right'>
            <a href='javascript:void(0);' @click="changeStep('next')" class='botNavLink row no-gutters navLinkDisabled'>
              <div class='col'></div>
              <div class='col-auto my-auto' style='padding-right:20px;height:25px;color: #336699; opacity: 0.5;'>
                {{$t('text.continue')}}
              </div>
              <div class='col-auto my-auto'>
                <img id='proceed-disabled' alt='' src='../assets/images/rightarrow_disabled.png' style='margin-right:15px;'/>
              </div> 
            </a>
          </div>
        </div>
        <div id='nav_completeorder' class='row d-none' style='margin-top:0px; '>
          <div class='col-auto no-gutters hoverSpot'>
            <button @click="changeStep('next')" class='btn btn-primary' style='margin-top:0px;margin-left:20px;min-width:180px;'>{{$t('text.page12_completeorder')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "../utils/bus.js";

export default {
  methods: {
    // Called when the step/page is moved forward or backward. This runs validation on the fields, and commits the values to the Store.
    changeStep(navigationDirection) {
      let doValidation=false;
      let skipNavigation=false;
      let targetStep="";

      if (navigationDirection==="next"&&this.$route.path==="/Questionnaire1"){
        if(document.getElementById("mq1n").checked===true) {
          document.getElementById("nav_previous").style.display = "none";
          document.getElementById("nav_next").style.display = "none";
          document.getElementById("mq1y").setAttribute("disabled","disabled");
          document.getElementById("not_eligible_warning").style.display = "block";

          skipNavigation=true;
        }
        else if (document.getElementById("mq1y").checked===false) {
          skipNavigation=true;
        }
      }

      // Skip Additional Travellers name if only 1 traveller
      if (navigationDirection ==="next"&&this.$route.path==="/ApplicantInfo"&&this.$store.state.numberOfTravellers==="1") {
        targetStep="/PaymentInfo";
        doValidation=true;
      } 
      else if (navigationDirection ==="previous"&&this.$route.path==="/PaymentInfo"&&this.$store.state.numberOfTravellers==="1") {
        targetStep="/ApplicantInfo";
      }
      // Don't migrate if no coverage types checked on page 2
      else if(navigationDirection==="next"&&this.$route.path==="/TypeOfCoverage"&&document.getElementById("wantsCancellation").checked===false&&document.getElementById("wantsMedical").checked===false){
        skipNavigation=true;
      }
      // Show Questionnaire if age of oldest traveller is 60 or older
      else if (navigationDirection==="next"&&this.$route.path==="/TravelPlans"&&document.getElementById("numberOfTravellers").value==="1"){
        if(document.getElementById("oldestTraveller").value>=60&&this.$store.state.wantsMedical===true){
          targetStep="/Questionnaire1";
          doValidation=true;
        }
        else {
          targetStep="/Quote";
          doValidation=true;
        }
      }
      else if (navigationDirection ==="next"&&this.$route.path==="/TravellerAges") {
        const numberOfTravellers = parseInt(this.$store.state.numberOfTravellers || "0", 10);
        const departureMoment = this.$moment(this.$store.state.departureDate, "MM/DD/YYYY", true);
        const calculationBase = departureMoment.isValid() ? departureMoment : this.$moment();
        let oldestTravellerAge = 0;

        for (let i = 1; i <= numberOfTravellers; i += 1) {
          const travellerDob = this.$moment(this.$store.state[`traveller${i}_dob`], "MM/DD/YYYY", true);
          if (travellerDob.isValid()) {
            const age = calculationBase.diff(travellerDob, "years", false);
            if (!Number.isNaN(age) && age > oldestTravellerAge) {
              oldestTravellerAge = age;
            }
          }
        }

        if (oldestTravellerAge > 0) {
          this.$store.commit("updateOldestTraveller", oldestTravellerAge);
        }

        if (oldestTravellerAge >= 60 && this.$store.state.wantsMedical === true) {
          targetStep="/Questionnaire1";
          doValidation=true;
        }
        else {
          targetStep="/Quote";
          doValidation=true;
        }
      } else if (navigationDirection ==="previous"&&this.$route.path==="/Quote"&&this.$store.state.wantsMedical===true){
        if(this.$store.state.oldestTraveller>=60){
          targetStep="/Questionnaire3";
        }
        else if(this.$store.state.numberOfTravellers==="1"){
          targetStep="/TravelPlans";
        }
      } else if (navigationDirection ==="previous"&&this.$route.path==="/Quote"&&this.$store.state.wantsMedical===false&&this.$store.state.numberOfTravellers==="1"){
        targetStep="/TravelPlans";
      } else if(navigationDirection==="previous"&&this.$route.path==="/Questionnaire1"&&this.$store.state.numberOfTravellers==="1"){
          targetStep="/TravelPlans"
      }
      // Otherwise navigate normally
      if(targetStep===""){
        console.log("BottomNav: Current route info:", {
          path: this.$route ? this.$route.path : 'no route',
          name: this.$route ? this.$route.name : 'no name',
          meta: this.$route ? this.$route.meta : 'no meta',
          navigationDirection: navigationDirection
        });
        
        if (this.$route && this.$route.meta) {
          if (navigationDirection === "next") {
            targetStep = this.$route.meta.nextStep || "";
            doValidation=true;
            console.log("BottomNav: Next step from meta:", this.$route.meta.nextStep);
          } else {
            targetStep = this.$route.meta.previousStep || "";
            console.log("BottomNav: Previous step from meta:", this.$route.meta.previousStep);
          }
        } else {
          console.error("BottomNav: No route or route meta available");
        }
      }
            
      console.log("BottomNav: Final navigation decision:", {
        skipNavigation: skipNavigation,
        hasRoute: !!this.$route,
        targetStep: targetStep,
        targetStepType: typeof targetStep
      });
      
      // Only emit if we have a valid target step
      if(skipNavigation===false && this.$route && targetStep && targetStep !== "") {
        bus.$emit("changeStep", this.$route.path, targetStep, doValidation);
      }
    }
  }
};
</script>

<style>
.btn-primary {
  color: white;
  font-family: Arial;
  border: 0px;
  background-color: rgb(51, 102, 153);
  height: 40px;
  width: 150px;
  border-radius: 3px;
}

a.botNavLink:visited,
a.botNavLink:link,
a.botNavLink:active,
a.botNavLink {
  padding:1px;    
  color: #333333;
}
a.navLink:hover {
    text-decoration:underline;
}

.navLinkDisabled {
  cursor: default !important;
}
a.navLinkDisabled:hover {
  text-decoration:none;
}
</style>